import { atom } from "jotai";

export const isDeleteCanvasModalOpenAtom = atom(false);

isDeleteCanvasModalOpenAtom.debugLabel = "isDeleteCanvasModalOpenAtom";
